import React from "react";
import LegalPage from "@/components/LegalPage";
import { useTranslation } from "@/lib/i18n";

export default function Impressum() {
  const { t } = useTranslation();
  return (
    <LegalPage
      title={t("legal.impressum.title")}
      lastUpdated={t("legal.impressum.last_updated")}
      testId="impressum-page"
      intro={t("legal.impressum.intro")}
      sections={[
        { heading: t("legal.impressum.s1_h"), body: [t("legal.impressum.s1_b1"), t("legal.impressum.s1_b2"), t("legal.impressum.s1_b3")] },
        { heading: t("legal.impressum.s2_h"), body: t("legal.impressum.s2_b") },
        { heading: t("legal.impressum.s3_h"), body: t("legal.impressum.s3_b") },
        { heading: t("legal.impressum.s4_h"), body: t("legal.impressum.s4_b") },
        { heading: t("legal.impressum.s5_h"), body: t("legal.impressum.s5_b") },
      ]}
    />
  );
}
